export type Heading = {
  level: 2 | 3;
  text: string;
  id: string;
};

export function slugify(text: string): string {
  return text
    .toLowerCase()
    .replace(/ą/g, "a")
    .replace(/ć/g, "c")
    .replace(/ę/g, "e")
    .replace(/ł/g, "l")
    .replace(/ń/g, "n")
    .replace(/ó/g, "o")
    .replace(/ś/g, "s")
    .replace(/ź|ż/g, "z")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}

export function extractHeadings(content: string): Heading[] {
  const headings: Heading[] = [];

  for (const line of content.split("\n")) {
    const h3 = line.match(/^### (.+)$/);
    if (h3) {
      headings.push({ level: 3, text: h3[1].trim(), id: slugify(h3[1].trim()) });
      continue;
    }
    const h2 = line.match(/^## (.+)$/);
    if (h2) {
      headings.push({ level: 2, text: h2[1].trim(), id: slugify(h2[1].trim()) });
    }
  }

  return headings;
}
